import { Button, TypographyDetail } from '@seen/ui'
import type { ReactNode } from 'react'
import {
  INBOX_CATEGORIES,
  type InboxCategoryId,
} from '#src/hooks/inbox/inboxCategories.ts'

export interface InboxCategoryBarProps {
  selectedCategory: InboxCategoryId
  onSelectCategory: (category: InboxCategoryId) => void
  counts: Record<InboxCategoryId, number>
  /**
   * When true, count badges show a pulsing placeholder instead of the number.
   * Used while background-fetching remaining notification pages so users know
   * the counts are not yet final.
   */
  isLoading?: boolean
}

export function InboxCategoryBar({
  selectedCategory,
  onSelectCategory,
  counts,
  isLoading = false,
}: InboxCategoryBarProps): ReactNode {
  return (
    <div className="flex scrollbar-none items-center gap-1 overflow-x-auto px-pagex-default py-1.5 lg:px-pagex-lg">
      {INBOX_CATEGORIES.map((category) => {
        const count = counts[category.id]
        const isSelected = selectedCategory === category.id

        return (
          <Button
            key={category.id}
            variant="ghost"
            size="xs"
            selected={isSelected}
            onClick={() => {
              onSelectCategory(category.id)
            }}
          >
            {category.label}
            {isLoading ? (
              <span className="ml-0.5 inline-block h-2.5 min-w-4 animate-pulse rounded bg-frame-foreground-secondary/30" />
            ) : (
              count > 0 && (
                <TypographyDetail className="ml-0.5 text-frame-foreground-secondary">
                  {count}
                </TypographyDetail>
              )
            )}
          </Button>
        )
      })}
    </div>
  )
}
